import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-related-products-slider .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-related-products-slider__swiper--${index}`
		);

		const cardsPerSlide = slider.dataset.cardsPerSlide || 4;

		const settings = {
			//loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: cardsPerSlide,
				},
			},
			navigation: {
				prevEl: `.block-related-products-slider__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-related-products-slider__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-related-products-slider__swiper--${index} .swiper-pagination`,
				clickable: true,
			},
		};

		new Swiper(slider, settings);
	});
}
